import showMessage from "components/showMessage"

/**
 * sequence collectionに登録されたaccessionNoを抽出し、同時に1カウントアップする
 * @param db
 * @param length
 */
export const getSequenceNo = async (db?: Realm.Services.MongoDBDatabase | null, length?: Number | null) => {
  const MAX_RETRY = 6;
  let retryCount = 0;
  let seqNo: number = 0;
  while (retryCount < MAX_RETRY) {
    try {
      const filter = { productId: 'accessionNo' };
      const update = { $inc: { accessionNo: length || 1 } };
      const result = await db?.collection("sequence").findOneAndUpdate(filter, update);
      seqNo = result.accessionNo;

      const check = await db?.collection('bookings').findOne({ _id: String(seqNo) });
      if (!check) {
        return seqNo;
      }
      retryCount++;
      console.log(`アクセッション番号取得に失敗しました。${retryCount}回目`);
      continue;
    } catch (e) {
      if (e instanceof Error) await showMessage(`アクセッション番号の取得時にエラーが発生しました。\r\n${e.message}`, { error: true });
    }
  }
  return seqNo;
}
